// 📦 utils/showSystemNotification.js

/**
 * Affiche une notification native du système d'exploitation.
 * Fonctionne uniquement si l'utilisateur a accordé la permission.
 * Utilisable même en premier plan.
 */
const showSystemNotification = (title, body) => {
    if (typeof Notification === "undefined") {
      return;
    }

    if (Notification.permission === "granted") {
      new Notification(title, {
        body,
        icon: "/images/icon-192x192.png", // 💡 change si besoin
      });
    } else {
      console.warn("🚫 Permission de notification non accordée.");
    }
  };
  
  export default showSystemNotification;
  